import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useCompleteBooking } from '../../api/use-complete-booking';
import { BrandedLayout } from '../../components/layouts/branded-layout';
import { useInviteStore } from '../../store/use-invite-store';

export function Confirmation() {
  const { t } = useTranslation('page.confirmation');
  const { invite } = useInviteStore();
  const { execute } = useCompleteBooking();

  // This should complete the online booking and update the store triggering an
  // automatic navigation to the /completed url
  useEffect(() => {
    execute();
  }, [execute]);

  return (
    <BrandedLayout>
      <h1 className="title">
        <Trans
          i18nKey="title"
          t={t}
          values={invite}
          components={{
            br: <br />,
          }}
        />
      </h1>
    </BrandedLayout>
  );
}
